import React, { useCallback, useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { useParams } from "react-router";
import ThemeLayout from "../../../layout/themeLayout";
import styles from "./boostpost.module.css";
import Button from "../../../component/Button/Button";
import PaymentMethod from "../../../Widgets/PaymentMethod";
import RoundImage from "../../../component/Image/RoundImage";
import { Link } from "react-router-dom";
import { MASTERCARD } from "../../../helpers/constant";
import Input from "../../../component/Input/Input";
import { gender as genderApi } from "../../../api/genders";
import { audience as audienceApi } from "../../../api/audiences";
import { countries as countriesApi } from "../../../api/countries";
import { states as statesApi } from "../../../api/states";
import { cities as citiesApi } from "../../../api/cities";
import { useDispatch, useSelector } from "react-redux";
import { currencyFormat, getFormData } from "../../../helpers/utility";
import { boosts as boostsApi } from "../../../api/boosts";
import Error from "../../../component/Error/Error";
import Joi from "joi";
import { users as usersApi } from "../../../api/users";
import { setErrorMessages, validateRequired } from "../../../helpers/validationMessages";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { posts } from "../../../api/posts";

const BoostPost = React.memo(() => {
    const { post_id } = useParams();
    const [post, setPost] = useState();
    const dispatch = useDispatch();
    const history = useHistory();
    const auth_user = useSelector((store) => store.user.user);

    // modal states and variables
    const [showmodal, setShow] = useState(false);
    const [userCardDetails, setUserCardDetails] = useState([]);
    const [selectedTab, setSelectedTab] = useState(0);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const cardId = useRef();
    const boostBtn = useRef();

    const [errors, setErrors] = useState([]);

    const [genderValue, setGenderValue] = useState(0);

    const [audi, setAudi] = useState({
        max_target_audience: 400,
        min_target_audience: 100,
        minimum_budget_per_day: 180,
        minimum_recommended_boost_days: 4,
    });

    const [budgetError, setBudgetError] = useState({
        condition: false,
        text: "",
    });
    // const [gender, setGender] = useState();

    const boostRef = useRef();
    const [days, setDays] = useState(4);
    const [amount, setAmount] = useState(1000);
    // const [ageFrom, setAgeFrom] = useState(18);
    // const [ageTo, setAgeTo] = useState(65);
    const [audiencePerDay, setAudiencePerDay] = useState({
        min: 278,
        max: 1528,
    });

    const [calculatedTargetAudience, setCalculatedTargetAudience] = useState({
        min: 278,
        max: 1528,
    });

    const [budgetFactor, setBudgetFactor] = useState(1);
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    // const [selectedCountry, setSelectedCountry] = useState({});
    // const [selectedState, setSelectedState ] = useState({});
    // const [selectedCity, setSelectedCity ] = useState();
    const [gender, setGender] = useState([]);
    const [selectedGender, setSelectedGender] = useState();
    const [audience, setAudience] = useState([]);
    const [selectedAudience, setSelectedAudience] = useState(0);
    const [audienceParams, setAudienceParams] = useState({
        age_from: 18,
        age_to: 65,
        gender_to_target: 0,
        country_id: 0,
        state_id: 0,
        city_id: 0,
        name: ""
    })
    
    
    useEffect(() => {
        const selected = audience.filter(a => a.id == selectedAudience);

        if (selected.length > 0) {
            setAudienceParams({
                ...audienceParams,
                age_from: selected[0].age_from,
                age_to: selected[0].age_to,
                gender_to_target: selected[0].gender_to_target,
                country: selected[0].country,
                state: selected[0].state,
                city: selected[0].city,
                gender: selected[0].gender,
                name: selected[0].name
            })
        }
    }, [selectedAudience])

    //load user card details
    const getUserCardDetails = useCallback(() => {
        dispatch(
            usersApi({
                param_path: auth_user.id + "/user_card_details",
            })
        )
            .then((response) => {
                if (response.success) {
                    setUserCardDetails(response.data);
                    if (response.data.length > 0) {
                        cardId.current = response.data.filter((cd) => cd.is_primary)[0].id;
                    }
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }, [auth_user.id, dispatch]);

    useEffect(() => {
        dispatch(
            posts({
                param_path: post_id,
            })
        )
            .then((response) => {
                if (response.success) {
                    setPost(response.data);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }, [dispatch]);

    //load user card details
    const getAudienceCount = () => {
        dispatch(
            boostsApi({
                param_path: `${post_id}/audience_count`,
                method: "POST",
                data: {
                    age_from: audienceParams.age_from,
                    age_to: audienceParams.age_to,
                    gender_to_target: audienceParams.gender_to_target,
                    days,
                    budget: amount,
                    country_id: audienceParams.country_id,
                    state_id: audienceParams.state_id,
                    city_id: audienceParams.city_id
                },
            })
        )
            .then((response) => {
                setAudi(response.data);
                setAudiencePerDay({
                    min: response.data.min_target_audience * budgetFactor,
                    max: response.data.max_target_audience * budgetFactor,
                });
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const setCard = (card_id) => {
        cardId.current = card_id;

        setUserCardDetails((p) =>
            p.map((uc) => {
                if (uc.id === card_id) {
                    uc.is_primary = 1;
                } else {
                    uc.is_primary = 0;
                }
                return uc;
            })
        );
    };

   

    const handleGenderChange = ({ currentTarget }) => {
        // setSelectedGender(parseInt(currentTarget.value));
        console.log('curent tarrget before', currentTarget.value)
        setAudienceParams({
            ...audienceParams, gender_to_target: currentTarget.value
        })
    };

    const handleAudienceChange = ({ currentTarget }) => {
        if(selectedTab == 0){
            setSelectedAudience(0);
            return;
        }
        setSelectedAudience(parseInt(currentTarget.value));

        const filtered = audience.filter(a => a.id == currentTarget.value);

        setAudienceParams({
            ...audienceParams,
            name: filtered[0].name
        })

    };

    const handleCountryChange = (e) => {
        // setSelectedCountry(e.target.value);

        setAudienceParams({
            ...audienceParams,
            country_id: e.target.value
        });

        if (e.target.value != 0) {
            getStates(e.target.value);
        } else {
            setStates([]);
        }
    };

    const handleStateChange = (e) => {
        // setSelectedState(e.target.value);
        setAudienceParams({
            ...audienceParams,
            state_id: e.target.value
        });

        if (e.target.value != 0) {
            getCities(e.target.value);
        } else {
            setCities([]);
        }

    }

    const handleCityChange = (e) => {
        // setSelectedCity(e.target.value);
        setAudienceParams({
            ...audienceParams,
            city_id: e.target.value
        });
    }

    const renderAudiences = () => {
        return (
            <select name="audience_id" onChange={handleAudienceChange}>
                {[
                    {
                        id: 0,
                        title: "Select Audience",
                    },
                ]
                    .concat(audience)
                    .map((a) => (
                        <option key={a.id} value={a.id}>
                            {a.title}
                        </option>
                    ))}
            </select>
        );
    };

    const renderGenders = () => {
        return (
            <select disabled={selectedTab == 1} name="gender_id" onChange={handleGenderChange}>
                {[
                    {
                        id: 0,
                        name: "All",
                    },
                ]
                    .concat(gender)
                    .map((g) => (
                        <option key={g.id} value={g.id}>
                            {g.name}
                        </option>
                    ))}
            </select>
        );
    };

    
    const renderCountries = () => {
        return (
            <select name="country_id" onChange={handleCountryChange}>
                {[
                    {
                        id: 0,
                        name: "All"
                    },
                ]
                .concat(countries)
                .map((c) => (
                    <option key={c.id} value={c.id}>
                        {c.name}
                    </option>
                ))}
            </select>
        );
    };

    const renderStates = () => {
        return (
            <select name="state_id" onChange={handleStateChange}>
                {[
                    {
                        id: 0,
                        name: "All"
                    },
                ]
                .concat(states)
                .map((s) => (
                    <option key={s.id} value={s.id}>
                        {s.name}
                    </option>
                ))}
            </select>
        );
    };

    const renderCities = () => {
        return (
            <select name="city_id" onChange={handleCityChange}>
                {[
                    {
                        id: 0,
                        name: "All"
                    },
                ]
                .concat(cities)
                .map((ct) => (
                    <option key={ct.id} value={ct.id}>
                        {ct.name}
                    </option>
                ))}
            </select>
        );
    };

    // load user card details
    useEffect(() => {
        getUserCardDetails();
    }, [dispatch, getUserCardDetails]);

    // load audience count
    useEffect(() => {
        getAudienceCount(audienceParams.age_from, audienceParams.age_to, audienceParams.gender_to_target, audienceParams.country_id, audienceParams.state_id, audienceParams.city_id);
        
    }, [dispatch, days, amount, audienceParams]);

    useEffect(() => {
        dispatch(countriesApi()).then(response => {
            if(response.success) {
                setCountries(response.data);
            }
        }).catch(err => {
            console.log(err);
        })
    }, [])

    useEffect(() => {
        dispatch(genderApi()).then(response => {
            if(response.success) {
                setGender(response.data);
            }
        }).catch(err => {
            console.log(err);
        })
    }, [])


    useEffect(() => {
        if (!auth_user?.id) {
            return;
        }
        dispatch(audienceApi()).then(response => {
            if(response.success) {
                setAudience(response.data);
            }
        }).catch(err => {
            console.log(err);
        })
    }, [auth_user])

    const getStates = (id) => {
        dispatch(statesApi({
            params: {
                country_id: id
                // selectedCountry
            }
        })).then(response => {
            if(response.success) {
                setStates(response.data)
            }
        })
        .catch(err => {
            console.log(err);
        })
    }

    const getCities = (id) => {
        dispatch(citiesApi({
            params: {
                state_id: id
                // selectedCountry
            }
        })).then(response => {
            if(response.success) {
                setCities(response.data)
            }
        })
        .catch(err => {
            console.log(err);
        })
    }

    const addCard = (new_card) => {
        setUserCardDetails((p) => [...p, new_card]);
        setShow(false);
    };

    const submitBoost = (event) => {
        event.preventDefault();
        setErrors({});
        const formData = new FormData(boostRef.current);

        const gender_id = audienceParams.gender_to_target;
        const audience_name = audienceParams?.name || formData.get("audience_name");
        const age_from = audienceParams.age_from;
        const age_to = audienceParams.age_to;
        const days = formData.get("days");
        const budget = formData.get("budget");

        const params = {
            data: {
                gender_to_target: gender_id,
                name: audience_name,
                age_from,
                age_to,
                days,
                budget,
                audience_id: selectedAudience,
                post_id,
                target_audience_min: Math.round(audi.min_target_audience, 2),
                target_audience_max: Math.round(audi.max_target_audience, 2),
                cost_per_view: audi.cost_per_view.toFixed(2),
                target_engagement_min: Math.round(audi.min_target_audience, 2),
                target_engagement_max: Math.round(audi.max_target_audience, 2),
                payment_method_id: cardId.current,
                country_id: audienceParams.country_id,
                state_id: audienceParams.state_id,
                city_id: audienceParams.city_id
            },

            param_path: "post/" + post_id,

            headers: {
                "Content-Type": "multipart/form-data",
            },

            method: "POST",
            // onUploadProgress: (progressEvent) => {
            //     progressRef.current?.setProgress((progressEvent.loaded / progressEvent.total) * 100);
            // }
        };

        const { error } = boostSchema.validate(params.data, { abortEarly: false });

        if (error) {
            const t = setErrorMessages(error);
            console.log(t);
            console.log(params)
            return setErrors(t);
        }

        params.data = getFormData(params.data);

        boostBtn.current?.showLoader(true);
        dispatch(boostsApi(params))
            .then((response) => {
                boostBtn.current?.showLoader(false);
                if (response.success) {
                    toast.success(response.message);
                    history.push("/");
                }
            })
            .catch((e) => {
                boostBtn.current?.showLoader(false);
                const t = setErrorMessages(e, true);

                if (e?.response?.data?.message) {
                    toast.error(e.response.data.message);
                }
                setErrors(t);
            });
    };

    // useEffect(() => {
    //     let bf = amount / days / audi.minimum_budget_per_day;
    //     setBudgetFactor(amount / days / audi.minimum_budget_per_day);

    //     let npd = {
    //         min: (audi.min_target_audience / days) * bf,
    //         max: (audi.max_target_audience / days) * bf,
    //     };

    //     const newPerDay = {
    //         min: (audi.min_target_audience / days) * bf,
    //         max: (audi.max_target_audience / days) * bf,
    //     };

    //     setCalculatedTargetAudience({
    //         min: parseInt((audi.min_target_audience / days) * bf * bf * days),
    //         max: parseInt((audi.max_target_audience / days) * bf * bf * days),
    //     });

    //     setAudiencePerDay(newPerDay);

    //     if (amount / days < audi.minimum_budget_per_day) {
    //         setBudgetError({
    //             condition: true,
    //             text: `Amount should be at least ${audi.minimum_budget_per_day} per day`,
    //         });
    //     } else {
    //         setBudgetError({
    //             condition: false,
    //             text: "",
    //         });
    //     }
    // }, [dispatch, audi, amount, days]);

    // useEffect(() => {
    //     setCalculatedTargetAudience({
    //         min: parseInt(audiencePerDay.min * budgetFactor * days),
    //         max: parseInt(audiencePerDay.max * budgetFactor * days),
    //     });
    // }, [dispatch, audiencePerDay]);

    const handleDaysChange = (e) => {
        setDays(parseInt(e.target.value));
    };

    const handleAmountChange = (e) => {
        setAmount(parseInt(e.target.value));
    };

    const handleAgeFromChange = (e) => {
        // setAgeFrom(parseInt(e.target.value));
        setAudienceParams({
            ...audienceParams, age_from: parseInt(e.target.value)
        })
    };

    const handleAgeToChange = (e) => {
        // setAgeTo(parseInt(e.target.value));
        setAudienceParams({
            ...audienceParams, age_to: parseInt(e.target.value)
        })
    };

    

    return (
        <ThemeLayout>
            <Modal size="lg" id="submit-modal" show={showmodal} onHide={handleClose} backdrop="static">
                <Modal.Header className="p-3 border-bottom">
                    <h4 className="modal-title">Add Payment Method</h4>
                    <Button className="close" type="link" onClick={handleClose}>
                        x
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <PaymentMethod auth_user={auth_user} addCard={addCard} />
                </Modal.Body>
            </Modal>
            <section>
                <div className={`gap`}>
                    <div className={`container`}>
                        <div className={`row`}>
                            <div className={`col-lg-12`}>
                                <form ref={boostRef} onSubmit={(e) => submitBoost(e)}>
                                    <div id="page-contents" className={`row merged20`}>
                                        <div className={`col-lg-12 mt-3 mb-3`}>
                                            <h3>Boost Post</h3>
                                        </div>
                                        <div className={`col-lg-6`}>
                                            <aside className={`${styles["sidebar"]} sidebar static left`}>
                                                <div className={`widget`}>
                                                    <h5>Audience</h5>
                                                    <div className={`row mt-2`}>
                                                        <div className={`col-lg-12`}>

                                                            <ul className={`nav nav-tabs nav-justified`}>
                                                                <li onClick={() => {
                                                                        setSelectedTab(0);
                                                                        setAudienceParams({
                                                                            ...audienceParams, name: ""
                                                                        })
                                                                    }} className={`nav-item`} title="Videos" data-toggle="tooltip">
                                                                    <Button className={`btn-block btn ${selectedTab == 0 ? "active btn-info" : "bg-light"}`} data-toggle="tab">
                                                                        <i className={`${styles["f-s-30"]} icofont-plus`} /> New
                                                                    </Button>
                                                                </li>
                                                                <li onClick={() => {setAudienceParams({...audienceParams, name: ""}); setSelectedTab(1);}} className={`nav-item`} title="Challenges" data-toggle="tooltip">
                                                                    <Button className={`btn-block btn ${selectedTab == 1 ? "active btn-info" : "bg-light"}`} data-toggle="tab">
                                                                        <i className={`${styles["f-s-30"]} icofont-list`} /> Previous
                                                                    </Button>
                                                                </li>
                                                            </ul>
                                                            <div className="tab-content mt-3">
                                                                <div className={`tab-pane show active`} id="create_new">
                                                                    <div className="row">
                                                                            {selectedTab == 0 && 
                                                                                <div className={`col-lg-6`}>
                                                                                    <Input className={`uk-input`} name="audience_name" styleType="floating" placeholder="Audience" />
                                                                                    {errors["name"] && <Error error={errors["name"]} />}

                                                                                </div>
                                                                            }

                                                                            {selectedTab == 1 && 
                                                                                <div className={`col-lg-12`}>
                                                                                    <label className={`${styles["pure-material-textfield-outlined"]} pure-material-textfield-outlined`}>
                                                                                        {renderAudiences()}
                                                                                        <span>Audience</span>
                                                                                    </label>
                                                                                    {errors["name"] && <Error error="Please select an Audience" />}
                                                                                </div>
                                                                            }

                                                                            
                                                                        <div className={`col-lg-6`}>
                                                                            {selectedTab == 0 &&
                                                                                <label className={`${styles["pure-material-textfield-outlined"]} pure-material-textfield-outlined`}>
                                                                                    {renderGenders()}
                                                                                    <span>Gender</span>
                                                                                </label>
                                                                            }
                                                                            {errors["gender_id"] && <Error error={errors["gender_id"]} />}
                                                                            
                                                                            {selectedTab == 1 && 
                                                                                <Input className={`uk-input`} name="" styleType="floating" placeholder="Gender" disabled={true} value={audienceParams.gender}/>
                                                                            }
                                                                        </div>
                                                                        <div className={`col-lg-6`}>
                                                                            <label className={`${styles["pure-material-textfield-outlined"]} pure-material-textfield-outlined`}>
                                                                                <Input
                                                                                    className={`${styles["hide-input-arrows"]}`}
                                                                                    type="number"
                                                                                    name="age_from"
                                                                                    placeholder=" "
                                                                                    value={audienceParams?.age_from}
                                                                                    onChange={(e) => handleAgeFromChange(e)}
                                                                                    readOnly={selectedTab == 1}
                                                                                    onKeyPress={(e) => {
                                                                                        if (["+", "-", "e", "."]?.includes(e.key)) {
                                                                                            e.preventDefault();
                                                                                        }
                                                                                    }}
                                                                                    onKeyDown={(e) => {
                                                                                        if (e.code == "ArrowUp" || e.code == "ArrowDown") {
                                                                                            e.preventDefault();
                                                                                        }
                                                                                    }}
                                                                                />
                                                                                <span>Age From</span>
                                                                            </label>
                                                                            {errors["age_from"] && <Error error={errors["age_from"]} />}
                                                                        </div>
                                                                        <div className={`col-lg-6`}>
                                                                            <label className={`${styles["pure-material-textfield-outlined"]} pure-material-textfield-outlined`}>
                                                                                <Input
                                                                                    className={`${styles["hide-input-arrows"]}`}
                                                                                    type="number"
                                                                                    name="age_to"
                                                                                    placeholder=" "
                                                                                    value={audienceParams?.age_to}
                                                                                    readOnly={selectedTab == 1}
                                                                                    onChange={(e) => handleAgeToChange(e)}
                                                                                    onKeyPress={(e) => {
                                                                                        if (["+", "-", "e", "."]?.includes(e.key)) {
                                                                                            e.preventDefault();
                                                                                        }
                                                                                    }}
                                                                                    onKeyDown={(e) => {
                                                                                        if (e.code == "ArrowUp" || e.code == "ArrowDown") {
                                                                                            e.preventDefault();
                                                                                        }
                                                                                    }}
                                                                                />
                                                                                <span>Age To</span>
                                                                            </label>
                                                                            {errors["age_to"] && <Error error={errors["age_to"]} />}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {/* <div className={`tab-pane fade ${selectedTab == 1 ? "show active" : ""}`} id="pre_listing">
                                                                    

                                                                    <div className="row">
                                                                        <div className={`col-lg-12`}>
                                                                        
                                                                        </div>
                                                                        <div className={`col-lg-6`}>
                                                                            <label className={`${styles["pure-material-textfield-outlined"]} pure-material-textfield-outlined`}>
                                                                                {renderGenders()}
                                                                                <span>Gender</span>
                                                                            </label>
                                                                            {errors["gender_id"] && <Error error={errors["gender_id"]} />}
                                                                        </div>
                                                                        <div className={`col-lg-6`}>
                                                                            <label className={`${styles["pure-material-textfield-outlined"]} pure-material-textfield-outlined`}>
                                                                                <Input
                                                                                    className={`${styles["hide-input-arrows"]}`}
                                                                                    type="number"
                                                                                    name="age_from"
                                                                                    placeholder=" "
                                                                                    value={ageFrom}
                                                                                    onChange={(e) => handleAgeFromChange(e)}
                                                                                    onKeyPress={(e) => {
                                                                                        if (["+", "-", "e", "."]?.includes(e.key)) {
                                                                                            e.preventDefault();
                                                                                        }
                                                                                    }}
                                                                                    onKeyDown={(e) => {
                                                                                        if (e.code == "ArrowUp" || e.code == "ArrowDown") {
                                                                                            e.preventDefault();
                                                                                        }
                                                                                    }}
                                                                                />
                                                                                <span>Age From</span>
                                                                            </label>
                                                                            {errors["age_from"] && <Error error={errors["age_from"]} />}
                                                                        </div>
                                                                        <div className={`col-lg-6`}>
                                                                            <label className={`${styles["pure-material-textfield-outlined"]} pure-material-textfield-outlined`}>
                                                                                <Input
                                                                                    className={`${styles["hide-input-arrows"]}`}
                                                                                    type="number"
                                                                                    name="age_to"
                                                                                    placeholder=" "
                                                                                    value={ageTo}
                                                                                    onChange={(e) => handleAgeToChange(e)}
                                                                                    onKeyPress={(e) => {
                                                                                        if (["+", "-", "e", "."]?.includes(e.key)) {
                                                                                            e.preventDefault();
                                                                                        }
                                                                                    }}
                                                                                    onKeyDown={(e) => {
                                                                                        if (e.code == "ArrowUp" || e.code == "ArrowDown") {
                                                                                            e.preventDefault();
                                                                                        }
                                                                                    }}
                                                                                />
                                                                                <span>Age To</span>
                                                                            </label>
                                                                            {errors["age_to"] && <Error error={errors["age_to"]} />}
                                                                        </div>
                                                                    </div>

                                                                </div> */}
                                                            
                                                            </div>

                                                        </div>
                                                        {/* <div className="col-lg-6"> */}

                                                            {/* <label className={`${styles["pure-material-textfield-outlined"]} pure-material-textfield-outlined`}>
                                                                {renderAudiences()}
                                                                <span>Audience</span>
                                                            </label> */}
                                                            {/* <Input className={`uk-input`} name="audience_id" styleType="floating-bottom-badge" placeholder="Audience" buttons={[
                                                                {
                                                                    btnText: "Add New",
                                                                    onActionClick: () => showAudienceModal()
                                                                }
                                                            ]} />
                                                                
                                                            {errors["audience_id"] && <Error error={errors["audience_id"]} />} */}
                                                        {/* </div> */}
                                                        {/* <div className={`col-lg-6`}>
                                                            <label className={`${styles["pure-material-textfield-outlined"]} pure-material-textfield-outlined`}>
                                                                {renderGenders()}
                                                                <span>Gender</span>
                                                            </label>
                                                            {errors["gender_id"] && <Error error={errors["gender_id"]} />}
                                                        </div>
                                                        <div className={`col-lg-6`}>
                                                            <label className={`${styles["pure-material-textfield-outlined"]} pure-material-textfield-outlined`}>
                                                                <Input
                                                                    className={`${styles["hide-input-arrows"]}`}
                                                                    type="number"
                                                                    name="age_from"
                                                                    placeholder=" "
                                                                    value={ageFrom}
                                                                    onChange={(e) => handleAgeFromChange(e)}
                                                                    onKeyPress={(e) => {
                                                                        if (["+", "-", "e", "."]?.includes(e.key)) {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                    onKeyDown={(e) => {
                                                                        if (e.code == "ArrowUp" || e.code == "ArrowDown") {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                />
                                                                <span>Age From</span>
                                                            </label>
                                                            {errors["age_from"] && <Error error={errors["age_from"]} />}
                                                        </div>
                                                        <div className={`col-lg-6`}>
                                                            <label className={`${styles["pure-material-textfield-outlined"]} pure-material-textfield-outlined`}>
                                                                <Input
                                                                    className={`${styles["hide-input-arrows"]}`}
                                                                    type="number"
                                                                    name="age_to"
                                                                    placeholder=" "
                                                                    value={ageTo}
                                                                    onChange={(e) => handleAgeToChange(e)}
                                                                    onKeyPress={(e) => {
                                                                        if (["+", "-", "e", "."]?.includes(e.key)) {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                    onKeyDown={(e) => {
                                                                        if (e.code == "ArrowUp" || e.code == "ArrowDown") {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                />
                                                                <span>Age To</span>
                                                            </label>
                                                            {errors["age_to"] && <Error error={errors["age_to"]} />}
                                                        </div> */}
                                                    </div>
                                                </div>
                                                <div className={`widget`}>
                                                    <h5>Select Region</h5>
                                                    <div className={`row mt-2`}>
                                                        <div className={`col-lg-4`}>
                                                            {selectedTab == 0 &&
                                                                <label className={`${styles["pure-material-textfield-outlined"]} pure-material-textfield-outlined`}>
                                                                        {renderCountries()}
                                                                        <span>Country</span>
                                                                </label>
                                                            }
                                                            {errors["country_id"] && <Error error={errors["country_id"]} />}
                                                            {selectedTab == 1 && 
                                                                <Input className={`uk-input`} name="" styleType="floating" placeholder="Country" disabled={true} value={audienceParams.country}/>
                                                            }
                                                        </div>
                                                        <div className={`col-lg-4`}>
                                                            {selectedTab == 0 &&
                                                                <label className={`${styles["pure-material-textfield-outlined"]} pure-material-textfield-outlined`}>
                                                                        {renderStates()}
                                                                        <span>State/Province</span>
                                                                </label>
                                                            }
                                                            {errors["state_id"] && <Error error={errors["state_id"]} />}
                                                            {selectedTab == 1 && 
                                                                <Input className={`uk-input`} name="" styleType="floating" disabled={true} placeholder="State" value={audienceParams.state}/>
                                                            }
                                                        </div>
                                                        <div className={`col-lg-4`}>
                                                            {selectedTab == 0 &&
                                                                <label className={`${styles["pure-material-textfield-outlined"]} pure-material-textfield-outlined`}>
                                                                        {renderCities()}
                                                                        <span>City</span>
                                                                </label>
                                                            }
                                                            {errors["city_id"] && <Error error={errors["city_id"]} />}
                                                            {selectedTab == 1 && 
                                                                <Input className={`uk-input`} name="" styleType="floating" disabled={true} placeholder="City" value={audienceParams.city}/>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </aside>
                                            <aside className={`sidebar static left`}>
                                                <div className={`widget`}>
                                                    <h5>Duration</h5>
                                                    <div className={`row mt-2`}>
                                                        <div className={`col-lg-6`}>
                                                            <label className={`${styles["pure-material-textfield-outlined"]} pure-material-textfield-outlined`}>
                                                                <input
                                                                    type="number"
                                                                    className={`${styles["hide-input-arrows"]}`}
                                                                    name="days"
                                                                    placeholder=""
                                                                    defaultValue={days}
                                                                    onKeyPress={(e) => {
                                                                        if (["+", "-", "e", "."]?.includes(e.key)) {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                    onKeyDown={(e) => {
                                                                        if (e.code == "ArrowUp" || e.code == "ArrowDown") {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                    onChange={handleDaysChange}
                                                                />
                                                                <span>Days</span>
                                                            </label>
                                                            {errors["days"] && <Error error={errors["days"]} />}
                                                        </div>

                                                        <div className={`col-lg-6`}>
                                                            <label className={`${styles["pure-material-textfield-outlined"]} pure-material-textfield-outlined`}>
                                                                <input
                                                                    type="number"
                                                                    className={`${styles["hide-input-arrows"]}`}
                                                                    name="budget"
                                                                    placeholder=" "
                                                                    defaultValue={amount}
                                                                    onKeyPress={(e) => {
                                                                        if (["+", "-", "e", "."]?.includes(e.key)) {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                    onKeyDown={(e) => {
                                                                        if (e.code == "ArrowUp" || e.code == "ArrowDown") {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                    onChange={handleAmountChange}
                                                                />
                                                                <span>Budget</span>
                                                            </label>
                                                            {errors["budget"] && <Error error={errors["budget"]} />}
                                                        </div>
                                                    </div>
                                                    {budgetError.condition == true && (
                                                        <div className={`row mt-2 ml-2`}>
                                                            <Error error={budgetError.text} />
                                                        </div>
                                                    )}
                                                    <div className={`row mt-2`}>
                                                        {(audi.min_target_audience > 0 || audi.max_target_audience > 0) && (
                                                            <div className={`col-lg-12 text-center`}>
                                                                <h6>
                                                                    An estimated {parseInt(audi.min_target_audience)}-{parseInt(audi.max_target_audience)} people reached per day
                                                                </h6>
                                                                <h1>
                                                                    {audi.cost_per_day && (
                                                                        <>
                                                                            <small>USD</small> <span>{currencyFormat(audi.cost_per_day.toFixed(2))}</span>
                                                                        </>
                                                                    )}
                                                                </h1>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </aside>
                                            <aside className="sidebar">
                                                <div className="widget">
                                                    <h5 className="widget-title border-bottom pb-2">
                                                        Select a Payment Method
                                                        <Button type="button" onClick={handleShow} className="see-all btn-sm text-white">
                                                            Add Payment Method
                                                        </Button>
                                                    </h5>
                                                    <ul className="company-posts">
                                                        {userCardDetails &&
                                                            userCardDetails.map((ucd) => (
                                                                <li className="d-flex align-items-center" onClick={() => setCard(ucd.id)} key={ucd.id}>
                                                                    <div className="card-image">
                                                                        <RoundImage src={MASTERCARD} alt={`card-img`} size="40px" />
                                                                    </div>
                                                                    <div className="position-meta flex-fill">
                                                                        <h6>{ucd.name}</h6>
                                                                        <small to={`/hunts/`}>{ucd.number}</small>
                                                                    </div>
                                                                    <div className="card-action-btns text-right">
                                                                        {ucd.is_primary == 1 && <span className="badge badge-success mr-2">Primary</span>}
                                                                        <i className="icofont-trash text-danger "></i>
                                                                    </div>
                                                                </li>
                                                            ))}
                                                    </ul>
                                                </div>
                                                {errors["payment_method_id"] && <Error error={errors["payment_method_id"]} />}
                                            </aside>
                                        </div>
                                        <div className={`col-lg-6`}>
                                            <div className={`main-wraper`}>
                                                <h5>Estimated Daily Results</h5>
                                                <div className={`setting-card`}>
                                                    <div className={`seting-mode`}>
                                                        <span>People reached</span>
                                                        {(audi.min_target_audience > 0 || audi.max_target_audience > 0) && (
                                                            <span className={`${styles["f-s-20"]} ${styles["fl-r"]} fl-r f-s-20`}>
                                                                {parseInt(audi.min_target_audience)}-{parseInt(audi.max_target_audience)}
                                                            </span>
                                                        )}
                                                    </div>
                                                    <div className={`seting-mode`}>
                                                        <span>Cost per view</span>
                                                        {audi.cost_per_view && <span className={`${styles["f-s-20"]} ${styles["fl-r"]} fl-r f-s-20`}>USD {audi.cost_per_view.toFixed(2)}</span>}
                                                    </div>
                                                    <hr />
                                                    <h5 className={`mb-3`}>Payment Summary</h5>
                                                    <span>Your ad will run for {days} days.</span>
                                                    <div className={`seting-mode`}>
                                                        <span className={`${styles["f-s-20"]} f-s-20`}>Total budget</span>
                                                        {(audi.min_target_audience > 0 || audi.max_target_audience > 0) && <span className={`${styles["f-s-20"]} ${styles["fl-r"]} fl-r f-s-20`}>USD {amount}</span>}
                                                    </div>
                                                </div>
                                                <div className={`row mt-2`}>
                                                    <div className={`col-lg-12`}>
                                                        <div className={`${styles["btnClass"]} ${styles["fl-r"]} btnClass mt-3 fl-r`}>
                                                            {/* <a href="#" title="" data-ripple="">Boost Post</a> */}
                                                            <Button ref={boostBtn} htmlType="submit" type="button">
                                                                Boost Post
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </ThemeLayout>
    );
});

export default BoostPost;

const boostSchema = Joi.object({
    audience_id: Joi.number(),
    country_id: Joi.number(),
    state_id: Joi.number(),
    city_id: Joi.number(),
    gender_to_target: Joi.number().messages({
        "number.base": validateRequired("Gender"),
    }),
    name: Joi.string()
        .required()
        .max(100)
        .messages({
            "string.empty": validateRequired("Audience Name"),
            "string.max": "Audience Name too long",
        }),
    age_from: Joi.number()
        .required()
        .min(1)
        .max(100)
        .messages({
            "number.base": validateRequired("Minimum Age"),
            "number.min": "Minimum Age should be at least 1",
            "number.max": "Maximum Age should be at most 100",
            "number.unsafe": "Please enter a realistic age!"
        }),
    age_to: Joi.number()
        .required()
        .min(1)
        .max(100)
        .messages({
            "number.base": validateRequired("Maximum Age"),
            "number.min": "Minimum Age should be at least 1",
            "number.max": "Maximum Age should be at most 100",
            "number.unsafe": "Please enter a realistic age!"
        }),
    days: Joi.number().required().min(4).max(30).messages({
        "number.base": "Days are required",
        "number.min": "Days should be at least 4",
        "number.max": "Days should be at most 30",
    }),
    budget: Joi.number()
        .required()
        .min(200)
        .max(999999)
        .messages({
            "number.base": validateRequired("Budget"),
            "number.min": "Budget should be at least 200",
            "number.max": "Budget should be at most 999999",
        }),

    post_id: Joi.number(),
    target_audience_min: Joi.number(),
    target_audience_max: Joi.number(),
    target_engagement_min: Joi.number(),
    target_engagement_max: Joi.number(),
    cost_per_view: Joi.number(),
    payment_method_id: Joi.number()
        .required()
        .messages({
            "number.base": validateRequired("Payment Method"),
            "any.required": validateRequired("Payment Method"),
        }),
});
